var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.4525V21.4525M21 17H13M17 27C22.5228 27 27 22.5228 27 17C27 11.4771 22.5228 7 17 7C11.4771 7 7 11.4771 7 17C7 18.5997 7.37562 20.1116 8.04346 21.4525C8.22094 21.8088 8.28001 22.2161 8.17712 22.6006L7.58151 24.8267C7.32295 25.793 8.20701 26.677 9.17335 26.4185L11.3994 25.8229C11.7839 25.72 12.1912 25.7791 12.5475 25.9565C13.8884 26.6244 15.4003 27 17 27Z",
    stroke: "#00274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/newChat.743d8303c3d6673ff443dbfafc3a304d.svg";
export { ForwardRef as ReactComponent };